'use strict';

import React, { PropTypes } from 'react';

import TabBar from '../molecules/TabBar';
import TabRouterLink from '../atoms/TabRouterLink';
import PureRenderMixin from '../mixins/PureRenderMixin';
import ZineSectionsStore from '../stores/ZineSectionsStore';
import createStoreMixin from '../mixins/createStoreMixin';
import Rotator from './Rotator';
import findIndex from 'lodash/array/findIndex';

var ZinesNavHeader = React.createClass({
  mixins: [PureRenderMixin, createStoreMixin(ZineSectionsStore)],

  propTypes: {
    scrolledSectionId: PropTypes.number,
    scrolled: PropTypes.bool.isRequired
  },

  getStateFromStores() {
    return {
      sections: ZineSectionsStore.getSections()
    };
  },

  render() {
    const { sections } = this.state;
    const { scrolled, scrolledSectionId } = this.props;
    const activeIndex = findIndex(sections, section => section.id === scrolledSectionId);

    if (!scrolled) {
      return (
        <TabBar context='NavBar'>
          <TabRouterLink to='feed'>
            My Feed
          </TabRouterLink>
          <TabRouterLink to='zines'>
            Collections
          </TabRouterLink>
        </TabBar>
      );
    }

    return (
      <Rotator activeIndex={activeIndex}>
        {sections.map(section => <span key={`rotator-${section.id}`}>{section.name}</span>)}
      </Rotator>
    );
  }
});

export default ZinesNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/ZinesNavHeader.jsx
 **/